export const purchasingRoutes = {
  CHECK_ORDER: "check-order",
  CHECKOUT: "checkout",
};
